import React, { useMemo } from 'react';
import {
  arrayOf, bool, exact, func, string, number,
} from 'prop-types';
import styled, { css } from 'styled-components';
import { Flex, Icon } from '@atoms';
import { MenuItem } from '@molecules';
import { Menu } from '@templates';
import { ReactComponent as Plus } from '@assets/plus.svg';

const MenuItems = ({
  onMenuItemAdd,
  onBackUp,
  onMenuItemSelect,
  menuItems,
  categories,
  subcategories,
  selectedCategoryId,
}) => {
  const memoizedItems = useMemo(() => (
    menuItems.map(({
      id,
      imageSrc,
      isMustTry,
      name,
      isActive,
      price,
      specialPrice,
      subtitle,
      subcategoryId,
    }) => (
      <MenuItem
        specialPrice={specialPrice}
        subcategoryId={subcategoryId}
        subtitle={subtitle}
        key={id}
        imageSrc={imageSrc}
        isActive={isActive}
        isMustTry={isMustTry}
        name={name}
        price={price}
        onMenuItemSelect={onMenuItemSelect(id)}
      />
    ))
  ), [menuItems]);

  return (
    <Menu
      hasMarginBottom
      onBackUp={onBackUp}
      isFooterVisible
      hasBackToTopButton
      categories={categories}
      subcategories={subcategories}
      selectedCategoryId={selectedCategoryId}
    >
      <Flex wrapFlex>
        <Wrapper
          itemsCenter
          justifyCenter
          column
          padding="md"
          onClick={onMenuItemAdd}
        >
          <Icon SVG={Plus} width="85px" height="85px" />
        </Wrapper>
        {memoizedItems}
      </Flex>
    </Menu>
  );
};

const Wrapper = styled(Flex)`
  ${({ theme: { color } }) => css`
    width: 50%;
    max-width: 50%;
    height: 55vw;
    background: ${color.grannySmith};
    border: 1px solid ${color.warmGrey};
  `}
`;

MenuItems.propTypes = {
  onMenuItemAdd: func.isRequired,
  onBackUp: func.isRequired,
  onMenuItemSelect: func.isRequired,
  menuItems: arrayOf(exact({
    subcategoryId: string,
    specialPrice: number,
    name: string,
    isActive: bool,
    price: number,
    subtitle: string,
    imageSrc: string,
    id: number,
    isMustTry: bool,
  })).isRequired,
  categories: arrayOf(exact({
    imageSrc: string,
    title: string,
    isActive: bool,
    id: number,
  })).isRequired,
  subcategories: arrayOf(exact({
    title: string,
    id: number,
  })).isRequired,
  selectedCategoryId: number.isRequired,
};

export default MenuItems;
